<template>
	<div
		:class="['radio-group', ...variantClassList, disabled && 'is-disabled']"
		:disabled="disabled"
		data-testid="radio-group"
	>
		<Label
			class="radio-group__label"
			:forElementId="uid"
			v-if="labelText"
			:labelText="labelText"
		>
			<template v-slot:leading>
				<slot name="beforeLabel"> </slot>
			</template>

			<template v-slot:trailing>
				<slot name="afterLabel"> </slot>
			</template>
		</Label>
		<div
			:class="[
				'radio-group__list',
				isHorizontal && 'radio-group__list--horizontal'
			]"
			data-testid="radio-group-list"
		>
			<div
				class="radio-group__item"
				v-for="option in options"
				:key="option.value"
			>
				<Radio
					:name="uid"
					:radioValue="option.value"
					v-model="selectedOption"
					:labelText="option.text"
					@change="onClick"
					:helpText="option.helpText"
					:width="option.width"
				/>
				<slot :name="option.value" />
			</div>
		</div>
	</div>
</template>

<script>
import Label from '@/components/forms/shared-stateless-elements/label.vue';
import Radio from '@/components/forms/selection-control/radio/radio.vue';
import baseComponentMixin from '@/mixins/base-component-mixin';
import variantClasses from './variant-classes/radio-group-variant-classes';
import componentVariantMixin from '@/mixins/component-variant-mixin';

export default {
	name: 'RadioGroup',
	mixins: [baseComponentMixin, componentVariantMixin],
	components: {
		Radio,
		Label
	},
	data() {
		return {
			selectedOption: this.value
		};
	},
	created() {
		this.variantClasses = variantClasses;
	},
	props: {
		labelText: {
			type: String,
			default: ''
		},
		helpText: {
			type: String,
			default: null
		},
		width: {
			type: [String, Number],
			default: null
		},
		value: {
			type: [String, Number, Boolean],
			default: ''
		},
		isHorizontal: {
			type: Boolean,
			default: false
		},
		/**
		 * Array of objects in format
		 * {
		 * text: 'text',
		 * value: 'value'
		 * }
		 */
		options: {
			type: Array,
			default: () => [],
			required: true,
			validator: items => {
				const validItems = items.filter(
					item =>
						Object.prototype.hasOwnProperty.call(item, 'text') &&
						Object.prototype.hasOwnProperty.call(item, 'value')
				);

				return validItems.length === items.length;
			}
		}
	},
	methods: {
		onClick() {
			const opt = this.options.find(
				el => el.value == this.selectedOption
			);
			this.$emit('input', opt.value);
			this.$emit('change', opt.value);
		}
	}
};
</script>

<style lang="scss" scoped>
.radio-group {
	display: inline-flex;
	flex-direction: column;

	&__label {
		margin-bottom: $gutter-md;
	}

	&__list {
		display: flex;
		flex-direction: column;

		.radio-group__item:not(:last-child) {
			margin-bottom: $gutter-md;
			margin-right: 0;
		}

		&--horizontal {
			flex-direction: row;
			align-items: flex-start;

			.radio-group__item:not(:last-child) {
				margin-right: $gutter-xl;
				margin-bottom: 0;
			}
		}
	}

	&__item {
		display: inline-flex;
		align-items: center;
	}
}

@include left-label('radio-group');
.radio-group--left-label {
	align-items: flex-start;
}
</style>
